<!-- 机构-学生考勤统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <!-- <p style="color:#606266;font-size:14px;">样例</p> -->
        <p style="color:#606266;font-size:14px;">截止日期: {{dayjs().format('YYYY-MM-DD')}}</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学生出勤率前五名</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学生出勤率后五名</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header> -->
       <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="选择时间">
            <el-date-picker 
				   	v-model="queryParams.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
				   	:picker-options="pickerOptions">
				   	</el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.teacher"
              clearable
              placeholder="选择授课教师"
              class="label"
            >
              <el-option v-for="item in teacherList"  :key="item.user_id+'teacherList'" :label="item.name" :value="item.user_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      <div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="className" label="课程名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classStudentNum" label="授课教师" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="signNum" label="上课地点" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="needAttendanceNum" label="应出勤人次" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lateNum" label="迟到人次" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="leaveNum" label="请假人次" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="a" label="实际出勤人次" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="b" label="出勤率" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
import { schoolTeacherList, } from "@/api/user/userCenter";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        teacher: "",
        name: "",
        time:'',
      },
      sourceList: [],
      semesterList: [],
      teacherList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
    };
  },
  watch: {

  },
  created() {
    // this.campusList = this.school_info?.slice() || [];
  },
  methods: {
    dayjs,
    async initData(){
      try{
        // 获取机构教师列表
        let teacherRes=await schoolTeacherList({
          top_org_id:sessionStorage.orgId,
          page:1,
          page_size:500,
          user_type: "1,5",
          need_role: "1",
        });
        if(teacherRes.code==='000000'){
          this.teacherList=teacherRes.result.member_list || [];
        }else{
          this.$message.error('获取老师信息失败');
        }
      }catch(err){
        console.log(err)
      }
    },
    async getDataList() {
      let start = "",
        end = "";
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId:this.queryParams.campus,
        gradeId: this.queryParams.grade,
        classId: this.queryParams.class,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };
      // this.tableData=[  
      //      {className:'竞技篮球	  ',  classStudentNum: "习华伊",  signNum: "武汉市解放小学",needAttendanceNum: "53",lateNum: '	1',leaveNum: '1',a: '	52 ',b: '98.11%',},
      //      {className:'优美声乐	  ',  classStudentNum: "寿歌姣",  signNum: "武汉市第六小学",needAttendanceNum: "48",lateNum: '	2',leaveNum: '1',a: '	47 ',b: '97.92%',},
      //      {className:'博学书法	  ',  classStudentNum: "昌琦嘉",  signNum: "武汉市第七小学",needAttendanceNum: "70",lateNum: '	2',leaveNum: '2',a: '	68 ',b: '97.14%',},
      //      {className:'幸福劳动	  ',  classStudentNum: "严姣婷",  signNum: "武汉市驿城区小",needAttendanceNum: "63",lateNum: '	1',leaveNum: '2',a: '	61 ',b: '96.83%',},
      //      {className:'世界百科课	',  classStudentNum: "明环凯",  signNum: "武汉市第九小学",needAttendanceNum: "51",lateNum: '	6',leaveNum: '2',a: '	49 ',b: '96.08%',},
      //      {className:'酷酷机器人	',  classStudentNum: "杨萍蓓",  signNum: "武汉市第一小学",needAttendanceNum: "66",lateNum: '	6',leaveNum: '3',a: '	63 ',b: '95.45%',},
      //      {className:'科技编程	  ',  classStudentNum: "庄萍雅",  signNum: "武汉实验小学	",needAttendanceNum: "42",lateNum: '	8',leaveNum: '2',a: '	40 ',b: '95.24%',},
      //      {className:'美学鉴赏课	',  classStudentNum: "奚秋叶",  signNum: "武汉市第二小学",needAttendanceNum: "44",lateNum: '	5',leaveNum: '4',a: '	40 ',b: '90.91%',},
      //      {className:'海滨少儿美术',  classStudentNum:"闫媛娣",  signNum: "武汉市第三小学",needAttendanceNum: "42",lateNum: '	8',leaveNum: '4',a: '	38 ',b: '90.48%',},
      //      {className:'温暖美术	  ',  classStudentNum: "强希礼",  signNum: "武汉市第十小学",needAttendanceNum: "40",lateNum: '	4',leaveNum: '5',a: '	35 ',b: '87.50%',},
      // ]  
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart = echarts.init(chartDom1);
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['竞技\n篮球', '优美\n声乐', '博学\n书法', '幸福\n劳动', '世界\n百科课'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [82, 100, 80, 95.87, 99.23],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['温暖\n美术', '海滨少儿\n美术', '美学\n鉴赏课', '科技\n编程', '酷酷\n机器人'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [71.81, 88.44, 85.71, 96.95, 90.42],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#51D6A6' },
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['课程1', '课程1', '课程1', '课程1', '课程1'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [110, 210, 256, 146, 388],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
  mounted() {
    if(this.semesterArr && this.semesterArr.length){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "第" + v.semester + "学期",
        id: v.schoolYear + "_" + v.semester,
      }));
    }
    this.initData();
    this.getDataList();
    // this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 48%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text{
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1{
    width:380px;
    height:280px;
  }
  #echarts-box2,#echarts-box3{
    width:500px;
    height:280px;
  }
  #echarts-box3{
    margin-top: 25px;
  }
}
</style>
